import ITranslations from './interfaces/ITranslations';
import Htmlizer from './htmlization/Htmlizer';
import Translation from './Translation';

export default class Translations implements ITranslations {
    private readonly missingTranslationSubstitute: string = '#';
    private translations: { [key: string]: Translation } = {};

    constructor(translations: { [key: string]: string}) {
        this.appendTranslations(translations);
    }

    public appendTranslations(translations: { [key: string]: string }) {
        Object.keys(translations).forEach((key) => {
            this.hasKey(key)
                ? this.updateTranslation(key, translations[key])
                : this.addTranslation(key, translations[key]);
        });
    }

    public getTranslation(key: string, ...parameters: any[]): string {
        return this.hasKey(key) ?
            this.translations[key].getText(...parameters) :
            this.missingTranslationSubstitute;
    }

    public getKeys(): string[] {
        return Object.keys(this.translations);
    }

    public hasKey(key: string): boolean {
        return key in this.translations;
    }

    public resolveTranslationReferences(): void {
        this.forEachTranslation((translation, key) => {
            translation = this.fillReferencedTranslations(translation);
            this.updateTranslation(key, translation);
        });
    }

    public htmlizeTranslations(): void {
        const htmlizer = new Htmlizer();
        this.forEachTranslation((translation, key) => {
            translation = htmlizer.htmlize(translation);
            this.updateTranslation(key, translation);
        });
    }

    private addTranslation(key: string, translation: string): void {
        if(this.hasKey(key))
            throw new Error(`Translation with key '${key}' already exists.`);

        this.translations[key] = new Translation(key, translation);
    }

    private updateTranslation(key: string, translation: string): void {
        if(!this.hasKey(key))
            throw new Error(`Translation with key '${key}' cannot be updated because it does not exist.`);

        this.translations[key].setText(translation);
    }

    private forEachTranslation(callback: (translation: string, key: string) => void): void {
        this.getKeys().forEach((key) => {
            var translation = this.getTranslation(key);
            callback(translation, key);
        });
    }

    private fillReferencedTranslations(translation: string): string {
        var parameterRegex = /\{@(.*?)\}/;
        var match;
        while(match = parameterRegex.exec(translation)) {
            var wholeMatch = match[0];
            var matchedKey = match[1];
            var matchedTranslation = this.getTranslation(matchedKey);
            translation = translation.replace(wholeMatch, matchedTranslation);
        }
        return translation;
    }
}
